module.exports = __webpack_public_path__ + "static/google-75a7b96374141c84ca1a7846ed972136.svg";